import { render, staticRenderFns } from "./FeedOffer.vue?vue&type=template&id=13cc341e&scoped=true"
import script from "./FeedOffer.vue?vue&type=script&lang=js"
export * from "./FeedOffer.vue?vue&type=script&lang=js"
import style0 from "./FeedOffer.vue?vue&type=style&index=0&id=13cc341e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cc341e",
  null
  
)

export default component.exports